import type { ManualLineAddition } from '@/api/cockpit';

export interface ManualLineDraft {
  id: string;
  productCode: string;
  productDisplay: string;
  quantity: string;
  unitOfMeasure: string;
  unitPrice: string;
  currency: string;
  reason: string;
}

export function manualLineDraftErrors(line: ManualLineDraft): Record<string, string> {
  const errors: Record<string, string> = {};
  if (!line.productCode.trim()) errors.productCode = 'Select a product.';
  const quantity = Number(line.quantity.replace(',', '.'));
  if (!line.quantity.trim() || !Number.isFinite(quantity) || quantity <= 0)
    errors.quantity = 'Quantity must be greater than zero.';
  if (!line.unitOfMeasure) errors.unitOfMeasure = 'Select a unit.';
  if (line.unitPrice.trim()) {
    const price = Number(line.unitPrice.replace(',', '.'));
    if (!Number.isFinite(price) || price < 0 || !Number.isFinite(price * quantity))
      errors.unitPrice = 'Enter a valid non-negative PO unit price.';
    if (!/^[a-z]{3}$/i.test(line.currency.trim()))
      errors.currency = 'Enter a three-letter currency code.';
  }
  if (line.reason.trim().length < 8)
    errors.reason = 'Explain the addition using at least 8 characters.';
  return errors;
}

export function serializeManualLineDraft(line: ManualLineDraft): ManualLineAddition {
  return {
    id: line.id,
    productCode: line.productCode.trim(),
    quantity: Number(line.quantity.replace(',', '.')),
    unitOfMeasure: line.unitOfMeasure,
    unitPrice: line.unitPrice.trim() ? Number(line.unitPrice.replace(',', '.')) : null,
    currency: line.unitPrice.trim() ? line.currency.trim().toUpperCase() : null,
    reason: line.reason.trim(),
  };
}

export function describeManualLineSaveError(error: unknown): string {
  const body = (
    error as { response?: { data?: { detail?: string; fields?: { message?: string }[] } } }
  )?.response?.data;
  if (Array.isArray(body?.fields))
    return body.fields
      .map((field) => field.message)
      .filter(Boolean)
      .join(' ');
  return (
    body?.detail ??
    (error instanceof Error ? error.message : 'The corrections could not be saved. Try again.')
  );
}
